//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Fragment } from 'vue-fragment';
import Swiper from "swiper";
export default {
  components: { Fragment },
  props: {
    slides: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isMobileState: false,
      swiper: null,
    }
  },
  computed: {
    canSwipeSlide() {
      return (direction) => {
        if (this.swiper) {
          const currentIndex = this.swiper.realIndex;
          if (direction > 0) {
            return currentIndex + 1 < this.swiper.slides.length;
          } else {
            return currentIndex !== 0;
          }
        }
        return false;
      }
    },
  },
  methods: {
    isMobile() {
      const isMobile = this.$mq === 'mobile';
      if (isMobile && !this.isMobileState) {
        if (this.swiper !== null) {
          this.swiper.destroy();
        }
        this.isMobileState = true;
        this.$nextTick(() => {
          this.swiper = new Swiper(this.$refs['mobileSwiper'], {
            slidesPerView: 'auto',
            allowTouchMove: true,
            observer: true,
            observeParents: true,
            spaceBetween: 20,
          });
        });
      } else if (!isMobile && this.isMobileState) {
        if (this.swiper !== null) {
          this.swiper.destroy();
        }
        this.swiper = null;
        this.isMobileState = false;
      }
      return isMobile;
    },
    goToSlide(slideNumber) {
      this.swiper.slideTo(slideNumber);
    },
    firePreviousSlide() {
      if (this.swiper) {
        const currentIndex = this.swiper.realIndex;
        let nextIndex = currentIndex - 1;
        if (nextIndex < 0) {
          return;
          // nextIndex = this.swiper.slides.length - 1;
        }
        this.goToSlide(nextIndex);
      }
    },
    fireNextSlide() {
      if (this.swiper) {
        const currentIndex = this.swiper.realIndex;
        let nextIndex = currentIndex + 1;
        if (nextIndex >= this.swiper.slides.length) {
          return;
          // nextIndex = 0;
        }
        this.goToSlide(nextIndex);
      }
    },

  }

}
